import { TypeOfUser, UmbrellaUserTypes } from '@pharmaplan/common';
import { createAction } from '@reduxjs/toolkit';

export const actionTypes = {
  SET_DATA: 'SET_DATA',
  RESET_ALL: 'RESET_ALL',
};

export const setData = createAction<{
  data: object;
  userType: TypeOfUser | UmbrellaUserTypes.professional;
  type: string;
  email: string;
}>(actionTypes.SET_DATA);

export const resetAll = createAction(actionTypes.RESET_ALL);
